import { ThemeProvider } from "@mui/material/styles";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import theme from "../Theme/Theme";
import { BreadCrumbsContextProvider } from "../Context/breadCrumbsContext";
import { BadgeContextProvider } from "../Context/badgeContext";
import { routes } from "../Utils/Constants";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Router = () => {
  return (
    <ThemeProvider theme={theme}>
      <ToastContainer
        hideProgressBar={false}
        closeButton={true}
        closeOnClick={true}
        style={{ margin: "10px", width: "auto" }}
      />
      <BreadCrumbsContextProvider>
        <BadgeContextProvider>
          <RouterProvider router={createBrowserRouter(routes)}></RouterProvider>
        </BadgeContextProvider>
      </BreadCrumbsContextProvider>
    </ThemeProvider>
  );
};
export default Router;
